import React from 'react';

const RewardScreen = () => <div>Reward Screen Placeholder</div>;
export default RewardScreen;